import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import useStateRef from 'react-usestateref';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { FacetLabelTooltipModal } from './FacetLabelTooltipModal';
import Helper from "../Helper";

function Facets(props) {
    const [showState, setShowState] = useState({})
    const [noOfFacetsOpen, setNoOfFacetsOpen, noOfFacetsOpenRef] = useStateRef()
    const [facetsAttributes, setFacetsAttributes, facetsAttributesRef] = useStateRef(props.facetsAttributes ? props.facetsAttributes : "")
    const [facetLabelDescription, setFacetLabelDescription, facetLabelDescriptionRef] = useStateRef()
    const [facetLabelName, setFacetLabelName, facetLabelNameRef] = useStateRef()
    const [isMobileView, setIsMobileView, isMobileViewRef] = useStateRef(props.isMobileView ? true : false)
    const [check, setCheck] = useState({})
    const [doorStatus, setDoorStatus] = useState({})
    const [noFollowList, setNofollowList] = useState([])
    const history = useHistory();

    function showMore(event) {
        var id = event.currentTarget.id
        var index = event.currentTarget.getAttribute('data-id')
        if (id === `more_${index}`) {
            setShowState({ ...showState, [`showState_${index}`]: true })
        } else {
            setShowState({ ...showState, [`showState_${index}`]: false })
        }
    }

    useEffect(() => {
        setShowState({ ...showState, [`showState_${props.index}`]: false })
        setDoorStatus({ ...doorStatus, [`doorStatus_${props.index}`]: true })
        setNofollowList(props.noFollowList ? props.noFollowList : [])
    }, [])

    useEffect(() => {
        if (props.facetsAttributes || props.isExpandAllFacets) {
            if (props.facetsAttributes) {
                setFacetsAttributes(props.facetsAttributes);
            }
            {
                props.value && Object.keys(props.value) && props.value[Object.keys(props.value)] && props.value[Object.keys(props.value)].length > 0 ? Object.entries(props.value).map(([eachKey, oneValue], indexxx) => {
                    var facetName = document.getElementById(`facet_${props.index}`);
                    var facetItem = document.getElementById(`index_${props.index}`);
                    if (isMobileViewRef.current == true) {
                        facetName = document.getElementById(`mobile_facet_${props.index}`);
                        facetItem = document.getElementById(`mobile_index_${props.index}`);
                    }

                    var show = false
                    var intialColapped = facetsAttributesRef.current[eachKey] && facetsAttributesRef.current[eachKey].initialCollapsed

                    // if(props.index < parseInt(props.noOfFacetsOpen) && Boolean(intialColapped) == false) {
                    //     console.log('if condition ----- ')
                    //     show = true
                    // }  
                    if (props.isExpandAllFacets === true || props.isExpandAllFacets === "true" || (intialColapped) === false || (intialColapped) === "false") {
                        show = true
                    }

                    if (show == true) {
                        if (facetItem && facetName) {
                            facetItem.classList.add("show");
                            facetName.classList.remove("collapsed");
                            facetName.setAttribute("aria-expanded", "true");
                        }
                    } else {
                        if (facetName) {
                            facetName.classList.add("collapsed");
                            facetName.setAttribute("aria-expanded", "false");
                        }
                    }
                }) : ""
            }
        }
    }, [props.facetsAttributes, props.isExpandAllFacets])


    useEffect(() => {
        if (props.facetsAttributes) {
            setFacetsAttributes(props.facetsAttributes);
        }
    }, [props.facetsAttributes])


    async function handleLabel(event) {
        var labelId = event.currentTarget.getAttribute("data-label-id");
        var labelName = event.currentTarget.getAttribute("data-label-name");
        var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/static/label-description/${labelId}`
        var response = await Helper.fetchCallFunction(Url, "GET", false, null, null)
        if (response.result == "success") {
            setFacetLabelDescription(response.response)
            setFacetLabelName(labelName)
            var modalElement = document.getElementById(`${labelName}`);
            var bootstrapModal = new bootstrap.Modal(modalElement);
            bootstrapModal.show();
        }
    }

    function handleRefinement(event) {
        event.preventDefault();
        var facetUrl = event.currentTarget.getAttribute("data-facet-url");
        var fieldName = event.currentTarget.getAttribute("data-facet-fieldName");
        var facetUrlName = event.currentTarget.getAttribute("data-facet-facetUrlName");
        if(isMobileViewRef.current) {
            window.location.href = facetUrl;
        } else {
            history.push(facetUrl)
        }
        window.dataLayer = window.dataLayer || []
        if (window.dataLayer.length > 0) {
            window.dataLayer.push({
                "event": "pageRefinement",
                "section_name": fieldName,
                "ref_label": facetUrlName
            });
        }
    }


    return (
        <>

            {props.value && Object.keys(props.value) && props.value[Object.keys(props.value)] && props.value[Object.keys(props.value)].length > 0 ? Object.entries(props.value).map(([eachKey, oneValue], indexxx) => {
                var initialNumberOfRefinements = facetsAttributesRef.current[eachKey] && facetsAttributesRef.current[eachKey].initialNumberOfRefinements ? parseInt(facetsAttributesRef.current[eachKey].initialNumberOfRefinements) : 8
                return (
                    <>
                        <li classNameName="list-group-item" style={{ listStyle: "none" }}>
                            <div className="accordion childFacets" style={{ width: "100%", border: "var(--bs-list-group-border-width) solid var(--bs-list-group-border-color)" }}>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                                        <button id={isMobileViewRef.current ? `mobile_facet_${props.index}` : `facet_${props.index}`} className={`${parseInt(noOfFacetsOpenRef.current)} ${props.index} accordion-button list-group-item-action accordion-button-header collapsed`} type="button" data-bs-toggle="collapse" data-bs-target={isMobileViewRef.current ? `#mobile_index_${props.index}` : `#index_${props.index}`} aria-expanded="false" aria-controls="panelsStayOpen-collapseOne">
                                            {eachKey && eachKey.includes("_") ? eachKey.replace("_", " ") : eachKey}
                                            {facetsAttributesRef.current[eachKey] && facetsAttributesRef.current[eachKey].facetLabelToolTip ? <p className='mx-1 tool-tip' onClick={handleLabel} id={`id_${props.index}`} data-label-name={eachKey} data-label-id={`${facetsAttributesRef.current[eachKey] && facetsAttributesRef.current[eachKey].facetLabel ? facetsAttributesRef.current[eachKey].facetLabel : ""}`}>
                                                <i class="bi bi-question-circle-fill tool-tip-icon"></i>
                                            </p> : ""}
                                        </button>
                                    </h2>
                                    <div id={isMobileViewRef.current ? `mobile_index_${props.index}` : `index_${props.index}`} className={`${props.index} accordion-collapse collapse accordion-body-width`} aria-labelledby="panelsStayOpen-headingOne">
                                        <ul className="c-accordion-list mt-2 mb-3">
                                            {oneValue && oneValue ? oneValue.map((eachValue, index) => {
                                                return (
                                                    <div className={`row ${!showState[`showState_${props.index}`] && index > parseInt(initialNumberOfRefinements) - 1 ? " d-none" : ""}`}>
                                                        <div id={eachValue.name} data-facet-fieldName={eachValue.fieldName ? eachValue.fieldName : ""} data-facet-facetUrlName={eachValue.name ? eachValue.name : ""} data-facet-url={eachValue.url ? eachValue.url : ""} onClick={(e)=>handleRefinement(e)} rel={noFollowList.length > 0 && noFollowList.includes(props.value.name ? props.value.name : "") ? "follow" : "nofollow"} className="c-refine-check form-check row">
                                                            {eachKey && eachKey.includes("Content_Category") || eachKey.includes("Product_Category") ? <label className="category form-check-label" htmlFor={`product_${index}`}>
                                                                {eachValue.name}&nbsp;<span className="form-check-value"> &nbsp;{eachValue.count ? "(" + eachValue.count + ")" : ""}</span>
                                                            </label> :
                                                                <label className="form-check-label" htmlFor={`product_${index}`}>
                                                                    <input id={`product_${index}`} className="form-check-input" type="checkbox" />
                                                                    {eachValue.name}&nbsp;<span className="form-check-value"> &nbsp;{eachValue.count ? "(" + eachValue.count + ")" : ""}</span>
                                                                </label>}
                                                        </div>
                                                    </div>
                                                )
                                            }) : ""}

                                            {oneValue && oneValue.length > parseInt(initialNumberOfRefinements) ?
                                                !showState[`showState_${props.index}`] ?
                                                    <button onClick={showMore} id={`more_${props.index}`} data-id={props.index} className="more-less-btn mt-1">Show All</button>
                                                    : <button onClick={showMore} id={`less_${props.index}`} data-id={props.index} className="more-less-btn mt-1">Show Less</button>
                                                : ""}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </>
                )
            }) : ""}
            {facetLabelDescriptionRef.current ? <FacetLabelTooltipModal facetLabelName={facetLabelNameRef.current ? facetLabelNameRef.current : ""} facetLabelDes={facetLabelDescriptionRef.current ? facetLabelDescriptionRef.current : ""} /> : ""}
        </>
    )
}
export default Facets